import EL from '../../../EL/EL.js';
import { makeStruct } from '../../../../enums/MODELS.js';
import { makeAttrStruct } from '../../../../enums/ModelAttr.js';
import { makeDataStruct } from '../../../../enums/ModelData.js';
// Model Structure
export const svgAnimationAttr = makeAttrStruct([
    ['begin'],
    ['dur'],
]);
export const svgAnimationData = makeDataStruct([]);
export const svgAnimationModel = makeStruct([
    ['attributes', svgAnimationAttr],
    ['data', svgAnimationData]
]);
// Simplified Model
export function svgAnimation(begin, dur) {
    return {
        attributes: svgAnimationAttr(begin, dur),
        data: svgAnimationData()
    };
}
/** Creates an Animation element within an SVG */
export default class SVGANIMATION extends EL {
    constructor(node, element, model) {
        super(node, element, model);
    }
}
